import { restrictUserInteractions, userPrevent} from '../../functions';
import { GSAPAnimationMixer, isDesktop, isIOS, isMobile, isTablet, projectMode } from '../../settings';
import { settingsData, threeJsVariables } from '../../settings';
import { ViewMode } from '../../common';
import { startProject, renderUpdateValuesOnDemand } from '../../app';
import { fitModelInViewport } from '../controls/zoomControl';
import { degToRad } from "three/src/math/MathUtils";
import TWEEN from '../../libs/tween.umd';
import { autoRotateTimerAction,
    setMinAndMaxControlsDistance } from '../controls/orbitControls'
import {
    PerspectiveCamera, Vector3
} from 'three';
import { centerMarker, setInitialMapCenter } from '../widgets/poi/poiv3'
import { updateShadowMap } from './lights';
import { menuHandler } from '../menu/menu';
import { BuildingOutline } from '../building/BuildingOutline';
import { disposeTiles } from './environment';
import { McID } from '../menu/contactUs/McID';
import { hideBuildingLabels, showBuildingLabels } from '../components/building-switch/buildingLabels';
import { Environment } from '../components/Environment/Environment';
import { Objects } from './Objects/Objects';
import { PointViewManager } from '../components/pointViewManager/PointViewManager';

export const MODE_ORBIT     = 0
export const MODE_ANIMATION = 3

export const ANIMATION_EMPTY = 0
export const ANIMATION_INTRO = 1
export const ANIMATION_MAP_TO_ORBIT = 2

let camera_angle_h = 0
let camera_angle_v = 0
let camera_mode = MODE_ORBIT
let camera_animation = 0
let camera_animation_duration = 0.0
let camera_animation_duration2 = 0.0
let _last_max_distance = 0


let target = config.threejs.orbitControls.target;
let distance = 100
let camera = null
const _v  = new Vector3()
const _v2 = new Vector3()
const startCamPosition = new Vector3();
let startAngle = 0;

export  function PerspectiveCamera_init () {
    const fov = isMobile ? 70 : 55;
    const aspect = window.innerWidth / window.innerHeight;
    const near = 0.1; //1.0;
    const far = 4000;
    camera = new PerspectiveCamera(fov, aspect, near, far);
    camera.rotation.order = 'YXZ';
    const position = config.threejs.camera.position;
    camera.position.set(position.x,position.y,position.z);
    camera.layers.enableAll();

    return camera;
}

export async function intro () {

    if (!projectMode.LiteMode.isActive() ||
      projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('regular') || projectMode.LiteMode.modeIs('rotate')))
        await fitModelInViewport();

    setCameraMode(MODE_ANIMATION,ANIMATION_INTRO);
}

export const setCameraMode = (mode,animation)=>{
    mode === MODE_ANIMATION ?
        threeJsVariables.orbitControls.enabled = false :
        threeJsVariables.orbitControls.enabled = !projectMode.AirMode.active;
        // threeJsVariables.orbitControls.enabled = true;

    projectMode.LiteMode.controlsToggle(false);

    camera_mode = mode;
    camera_animation = animation;
    renderUpdateValuesOnDemand(false);
    settingsData.needsRerender = true
};

export const cameraAnimationActive = () => {
    return camera_mode !== MODE_ORBIT;
};

export const introLoop = (delta)=> {

    if (settingsData.slideShowed) {
        setCameraMode(MODE_ORBIT, 0)
        setMinAndMaxControlsDistance(ViewMode.Orbit);
        startProject();
        updateShadowMap();
        if (!projectMode.AirMode.active) {
            threeJsVariables.orbitControls.enabled = true;
        }
        settingsData.projectLoaded = true;
    }

    if (!McID.active) {
        config.contactWidget?.active && !isDesktop && restrictUserInteractions(true);
    }
}

const set_camera_angles = ()=>{
    if (camera_angle_h>(2*Math.PI)){
        camera_angle_h = camera_angle_h - 2*Math.PI
    }
    if (camera_angle_h<0){
        camera_angle_h = 2*Math.PI + camera_angle_h
    }
    let x1 = Math.cos(camera_angle_h) ;
    let y1 = 0;
    let z1 = Math.sin(camera_angle_h) ;

    let x2 = x1*Math.cos(camera_angle_v) ;
    let y2 = Math.sin(camera_angle_v) ;
    let z2 = z1*Math.cos(camera_angle_v) ;

    let x = target.x + (x2)*distance;
    let y = target.y + (y2)*distance;
    let z = target.z + (z2)*distance;
    camera.position.set(x,y,z);
    camera.lookAt(target.x,target.y,target.z);
    camera.updateMatrixWorld(false);
    settingsData.needsRerender = true;
};

const getCameraHorizontalAngle = ()=>{
    _v2.set(camera.position.x,0,camera.position.z);
    _v.set(target.x,0,target.z).sub(_v2).normalize();

    let angle = 0;
    if (camera.position.z<target.z){
        _v2.set(1,0,0);
        angle = Math.PI + _v.angleTo(_v2)
    }else{
        _v2.set(-1,0,0);
        angle = _v.angleTo(_v2)
    }
    return angle;
};

const getDistanceToTarget = (p)=>{
    let x = target.x - p.x;
    let y = target.y - p.y;
    let z = target.z - p.z;
    return Math.sqrt(x*x+y*y+z*z);
};

export const moveFromBorder = ()=>{

    let o = threeJsVariables.trackballControls;

    let x = o.object.position.x;
    let y = o.object.position.y;
    let z = o.object.position.z;
    let dx = x - o.target.x;
    let dy = y - o.target.y;
    let dz = z - o.target.z;
    let d = Math.sqrt(dx*dx+dy*dy+dz*dz);

    let max1 = o.maxDistance*0.98;
    let step = (d-max1);
    dx = (dx/d)*step;
    dy = (dy/d)*step;
    dz = (dz/d)*step;

    const duration = {x:0};
    new TWEEN.Tween(duration)
    .to({x:1}, 200).easing(TWEEN.Easing.Linear.None).onUpdate(() => {
        o.object.position.x = x - dx*duration.x;
        o.object.position.y = y - dy*duration.x;
        o.object.position.z = z - dz*duration.x;
    }).onComplete(()=>{

    }).start()
};

export const OrbitToMap = (triggerMenuHandler = true)=>{
    if (camera_mode===MODE_ANIMATION || settingsData.activeViewMode !== ViewMode.Orbit){
        return;
    }

    if (projectMode.LiteMode.isActive()){
        setTimeout(() => {
            menuHandler({target: {dataset: {menuItem: 'map'}}});
        },1000);
        return projectMode.LiteMode.mapAnimation('toMap');
    }
    
    if (projectMode.AirMode.active) {
        return projectMode.AirMode.orbitToMapAnimation()
            .then(() => menuHandler({target: {dataset: {menuItem: 'map'}}}));
    }

    userPrevent(true);

    BuildingOutline.toggle(false);

    autoRotateTimerAction('cancel');
    setCameraMode(MODE_ANIMATION,ANIMATION_MAP_TO_ORBIT);
    Objects.visibilityToggle(true);
    PointViewManager.resetState();
    camera_animation_duration = 0.99;
    camera_animation_duration2 = 0.0;
    target = threeJsVariables.orbitControls.target;
    startCamPosition.copy(camera.position);
    let angle = getCameraHorizontalAngle();
    startAngle = angle;
    const deltaAngleH = shortestAngle(angle, degToRad(0));
    let dist = getDistanceToTarget(camera.position);
    const mapTransition = threeJsVariables.composer.getPass('map');
    mapTransition.active = true;
    mapTransition.scale = camera_animation_duration2;
    mapTransition.opacity = camera_animation_duration;
    settingsData.resolveTilesUpdate = false;

    return new Promise(resolve => {
        const duration = {x:0}
        new TWEEN.Tween(duration)
          .to({x:1}, 1500).easing(TWEEN.Easing.Linear.None)
          .onUpdate(() => {
            distance = dist + (1100-dist)*duration.x;
            camera_animation_duration = 0.99 - Math.max(0,(distance-400)/(1100-400));
            camera_animation_duration2 = Math.max(0,(distance-900)/(1100-900));

            camera_angle_h = angle + deltaAngleH * duration.x;
            // camera_angle_h = angle + (degToRad(0)-angle)*duration.x;
            camera_angle_v = degToRad(10) + (degToRad(90)-degToRad(10))*duration.x;
            set_camera_angles();
            mapTransition.scale = camera_animation_duration2;
            mapTransition.opacity = camera_animation_duration;
        })
          .onComplete(()=>{
            resolve();
            userPrevent(false);

            camera_animation_duration = 1.0;
            camera_animation_duration2 = 0.0;
            threeJsVariables.orbitControls.enabled = true;
            centerMarker();
            triggerMenuHandler && menuHandler({target: {dataset: {menuItem: 'map'}}},config.general);
            threeJsVariables.orbitControls.enabled = false;
    
            disposeTiles();
            
            setTimeout(()=>{
                mapTransition.active = false;
                mapTransition.scale = 0.0;
                mapTransition.opacity = 0.0;
                // const endPosition = config.threejs.camera.position;
                distance = Math.min(getDistanceToTarget(startCamPosition),threeJsVariables.orbitControls.maxDistance)*0.98;
                camera_angle_h = startAngle;
                camera_angle_v = degToRad(0);
                set_camera_angles();
                camera.lookAt(target.x,target.y,target.z);
                setCameraMode(MODE_ORBIT,0);
                renderUpdateValuesOnDemand(true);
            },200);
        })
          .start()
    });
}

function shortestAngle(from, to) {
    const PI2 = Math.PI * 2;
    const diff = (to - from + PI2) % PI2;
    return (diff > Math.PI) ? diff - PI2 : diff;
}

export const transferToBuilding = async (zoom)=>{
    if (camera_mode===MODE_ANIMATION || settingsData.activeViewMode === ViewMode.Cylinder){
        return
    }

    if (projectMode.LiteMode.isActive()){
        projectMode.LiteMode.mapAnimation('toOrbit');
        setCameraMode(MODE_ORBIT,0)
       return;
    }
    
    if (projectMode.AirMode.active) {
        projectMode.AirMode.mapToOrbitAnimation();
        setCameraMode(MODE_ORBIT,0);
        return;
    }

    userPrevent(true);
    autoRotateTimerAction('cancel')
    settingsData.resolveTilesUpdate = true;
    setCameraMode(MODE_ANIMATION,ANIMATION_MAP_TO_ORBIT)
    camera_animation_duration = 0.0
    camera_animation_duration2 = 0.0
    const mapTransition = threeJsVariables.composer.getPass('map');
    target = threeJsVariables.orbitControls.target;
    let dist = (threeJsVariables.trackballControls.minDistance + threeJsVariables.trackballControls.maxDistance) / 2;
    setInitialMapCenter();
    mapTransition.active = true;
    mapTransition.scale = camera_animation_duration2;
    mapTransition.opacity = camera_animation_duration;
    if (startAngle === 0) {
        startAngle = getCameraHorizontalAngle();
    }

    const polarDegrees = config.threejs.orbitControls.orbit.mapToOrbitPolarDegrees || 10;
    return new Promise(resolve => {
        const duration = {x:0}
        new TWEEN.Tween(duration)
          .to({x:1}, 1500).easing(TWEEN.Easing.Linear.None).onUpdate(() => {
            distance = 1100.0 + (dist-1100.0)*duration.x

            camera_animation_duration = 0.99 - Math.max(0,(distance-400)/(1100-400))
            camera_animation_duration2 = Math.max(0,(distance-700)/(1100-700))

            camera_angle_h = startAngle;
            camera_angle_v = degToRad(90) + (degToRad(polarDegrees)-degToRad(90))*duration.x
            set_camera_angles();

            camera.updateProjectionMatrix()

            mapTransition.scale = camera_animation_duration2;
            mapTransition.opacity = camera_animation_duration;

        }).onComplete(()=>{
            resolve();
            camera_animation_duration = 1.0
            camera_animation_duration2 = 0.0

            threeJsVariables.orbitControls.target.set(target.x,target.y,target.z)
            setCameraMode(MODE_ORBIT,0)
            threeJsVariables.orbitBuildingsNavigation.updateActiveButton();

            mapTransition.active = false;
            mapTransition.scale = 0.0;
            mapTransition.opacity = 0.0;

            BuildingOutline.toggle(true);
            autoRotateTimerAction('update');
            userPrevent(false);
        }).start()
    });
}

const updateCameraPositionByDistance = ()=>{
    let dist = getDistanceToTarget(camera.position);
    let max = threeJsVariables.orbitControls.maxDistance;
    if (dist>=threeJsVariables.orbitControls.maxDistance){
        let x = (target.x - camera.position.x)/dist;
        let y = (target.y - camera.position.y)/dist;
        let z = (target.z - camera.position.z)/dist;
        max = max*0.98;
        camera.position.x = target.z - x*max;
        camera.position.y = target.y - y*max;
        camera.position.z = target.z - z*max
    }
};

export const update = (delta)=>{

    if (_last_max_distance !== threeJsVariables.orbitControls.maxDistance) {
        updateCameraPositionByDistance();
        _last_max_distance = threeJsVariables.orbitControls.maxDistance;
    }

    if (camera_mode === MODE_ANIMATION) {
        switch (camera_animation) {
            case ANIMATION_INTRO: introLoop(delta);
                                  break;
            //case ANIMATION_MAP_TO_ORBIT: animation_map_to_orbit(delta)
            //                      break;

        }

        settingsData.needsRerender = true
    }
};


export class CameraMixer {
    constructor () {
        this.camera = threeJsVariables.perspectiveCamera;
        this.orbitContols = threeJsVariables.orbitControls;
        this.trackballControls = threeJsVariables.trackballControls;
    }

    createMixer(onStart = () => {},onComplete = () => {}) {
        GSAPAnimationMixer.registerNewMixer('camera',onStart,undefined,onComplete);
    }

    target(obj) {
        if (obj.isVector3) {

        }

    }



}
